import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-website-container',
  templateUrl: './website-container.component.html',
  styleUrls: ['./website-container.component.css']
})
export class WebsiteContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
   
  }

  sidebarVisible: boolean = true;

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }
}
